'use strict';

const dividerTokens = (theme) => ({
    dividerSize: '1px',
    dividerColor: theme.colors.border,
});

exports.dividerTokens = dividerTokens;
//# sourceMappingURL=divider.js.map
